import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';

// Components
import { WidgetReporteCirtularComponent } from './widget-reporte-circular.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import { WidgetToastModule } from '../widget-toast/widget-toast.module';
import { EncryptService } from 'src/app/_shared/encrypt';

@NgModule({
  declarations: [WidgetReporteCirtularComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgxLoadingModule,
    WidgetToastModule,

    ReactiveFormsModule,
    ToastrModule.forRoot()
  ],
  exports: [WidgetReporteCirtularComponent],
  providers: [EncryptService]
})
export class WidgetReporteCirtularModule { }
